var widget_default = {
  "card": "D1dhW",
  "link": "I5bKW",
  "container": "wpb11",
  "image": "OYZh0",
  "right": "y8qHs",
  "cardLayout": "gnG3D",
  "content": "_6j28F",
  "title": "ooJ6X",
  "subtitle": "IWLW1",
  "button": "ppQ7s",
  "button_disabled": "VJMUT",
  "buttonText": "B8I8j",
  "slimLayout": "_22Fya",
  "rtl": "d2oNO",
  "ltr": "UDHRJ"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
